export default "__VITE_ASSET__CC_U262x__"